export const foundationColorTokens = {
  background: {
    canvas: 'bg-canvas',
    surface: 'bg-surface',
    surfaceMuted: 'bg-surface-muted'
  },
  border: {
    subtle: 'border-border-subtle',
    strong: 'border-border-strong'
  },
  text: {
    primary: 'text-ink-primary',
    secondary: 'text-ink-secondary',
    muted: 'text-ink-muted',
    inverse: 'text-brand-foreground'
  },
  brand: {
    surface: 'bg-brand',
    surfaceHover: 'hover:bg-brand-hover',
    text: 'text-brand',
    foreground: 'text-brand-foreground'
  },
  status: {
    successSurface: 'bg-success-bg',
    successBorder: 'border-success-border',
    successText: 'text-success-text'
  },
  overlay: {
    scrim: 'bg-black/50'
  }
} as const;